
import seekAnzLinks from './seekAnz';
import {FooterLink} from "../../../../types.ts";

export const getLinks = (site: string): FooterLink[] => {
  switch (site) {

    default:
      return seekAnzLinks;
  }
};
